module.exports = __webpack_public_path__ + "static/media/logo.8ade3838.png";